module.exports = __webpack_public_path__ + "static/media/Comment.11c6e2b7.svg";